/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { CancelButton, ConfirmButton } from 'components/button/button.styled'
import { useState } from 'react'

import { FooterContainer, StyledDialog } from './useDeleteDialog.style'

export const useDeleteDialog = () => {
    const [isVisible, setIsVisible] = useState(false)
    const [onDeleteCallback, setOnDeleteCallback] = useState<(() => void) | null>(null)

    const show = (onDelete: () => void) => {
        setOnDeleteCallback(() => onDelete)
        setIsVisible(true)
    }

    const hide = () => {
        setIsVisible(false)
    }

    const onDelete = () => {
        if (onDeleteCallback) {
            onDeleteCallback()
            hide()
        }
    }

    interface DialogComponentProps {
        entityLabel: string // e.g., "a műsort", "a helyszínt"
        cascadeWarning?: string // e.g., "A törléssel minden hozzá tartozó előadás is törlésre kerül."
    }

    const DialogComponent: React.FC<DialogComponentProps> = ({ entityLabel, cascadeWarning }) => (
        <StyledDialog
            visible={isVisible}
            onHide={hide}
            header="Törlés megerősítése"
            footer={
                <FooterContainer>
                    <CancelButton label="Mégsem" icon="pi pi-times" onClick={hide} />
                    <ConfirmButton label="Törlés" icon="pi pi-check" onClick={onDelete} />
                </FooterContainer>
            }
        >
            <div>
                Biztosan törölni szeretné ezt {entityLabel}?
                {cascadeWarning && <p style={{ marginTop: '1em', color: '#d9534f', fontStyle: 'italic' }}>{cascadeWarning}</p>}
            </div>
        </StyledDialog>
    )

    return { show, hide, DialogComponent }
}
